import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAuth } from "../context/AuthContext";
import { useAlert } from "../context/AlertContext";
import { useLoading } from "../context/LoadingContext";
import { useWebsiteName } from "../context/WebsiteNameContext";
import { MAIN_MENU } from "../data/menu";
import { BellBadgeIcon, LogoutIcon } from "../data/iconImage";
import {
  Nav,
  Navbar,
  NavDropdown,
  Offcanvas,
  Container,
  Image,
  Button,
  Col
} from "react-bootstrap";
import AuthService from "../services/auth.service";

const NavMenubar = () => {
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const { user, setUser } = useAuth();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const menuItem = MAIN_MENU;

  const handleLogout = () => {
    setLoading(true);
    AuthService.logout(user?.refreshToken)
      .then((_) => setUser(null))
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  return (
    <Navbar
      bg="white"
      expand="lg"
      className="py-0 position-sticky top-0 border-bottom border-light-subtle"
      style={{ height: "80px", zIndex: "1046" }}
    >
      <Container fluid>
        <Navbar.Brand
          href="/"
          className="me-0 p-2 fw-bold fs-2 border-end border-light-subtle"
          style={{ width: "276px", height: "80px" }}
        >
          <Nav.Item className="w-100 h-100 d-flex align-items-center">
            <Image
              height="100%"
              src={`${process.env.REACT_APP_STORAGE_URL}/company-logo/${user?.Com_Logo}`}
              alt="Logo Icon"
            />
          </Nav.Item>
        </Navbar.Brand>

        <Navbar.Offcanvas
          show
          scroll={true}
          backdrop={false}
          className="border-light-subtle"
          style={{ top: "80px" }}
        >
          <Offcanvas.Body>
            {menuItem?.map(({ name, label, path, img, submenu }) =>
              !submenu ? (
                <NavLink
                  key={name}
                  to={path}
                  className="nav-link"
                  activeclassname="active"
                >
                  <Image className="me-3" src={img?.src} alt={img?.alt} />
                  <span className="w-75 text-truncate">{label}</span>
                </NavLink>
              ) : (
                <NavDropdown
                  key={name}
                  className="w-100"
                  renderMenuOnMount
                  title={
                    <>
                      <Image className="me-3" src={img?.src} alt={img?.alt} />
                      <span className="w-75 text-truncate">{label}</span>
                    </>
                  }
                >
                  {submenu?.map((sub) => (
                    <NavDropdown.Item
                      key={sub?.name}
                      to={sub?.path}
                      as={NavLink}
                      className="nav-link"
                      activeclassname="active"
                    >
                      <span className="w-100 text-truncate">{sub?.label}</span>
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              )
            )}

            <Button
              className="nav-link w-100 text-start"
              onClick={handleLogout}
            >
              <Image className="me-3" src={LogoutIcon} alt="Logout Icon" />
              <span className="w-75 text-truncate">ออกจากระบบ</span>
            </Button>
          </Offcanvas.Body>
        </Navbar.Offcanvas>

        <Nav className="justify-content-sm-between justify-content-end flex-grow-1 flex-row px-sm-3 px-1 py-2 ">
          <Col
            sm={9}
            className="w-auto ps-2 py-1 d-none d-sm-flex align-items-center fw-bold fs-2 text-dark"
          >
            <Helmet onChangeClientState={(hel) => setWebsiteName(hel?.title)} />
            {websiteName}
          </Col>

          <Col
            sm={9}
            className="w-auto py-1 d-flex justify-content-end align-items-center"
          >
            <Nav.Link className="me-lg-0 me-md-3 d-none d-sm-block" href="#">
              <Image src={BellBadgeIcon} alt="Bell Badge Icon" />
            </Nav.Link>

            <NavDropdown
              align="end"
              className="d-none d-md-block"
              title={
                <Col
                  className="d-flex justify-content-center align-items-center fw-medium fs-4 text-dark "
                  style={{ width: "140px", height: "40px" }}
                >
                  {user?.username}
                </Col>
              }
            >
              <NavDropdown.Item onClick={handleLogout} className="fs-5">
                <Image className="me-3" src={LogoutIcon} alt="Logout Icon" />
                ออกจากระบบ
              </NavDropdown.Item>
            </NavDropdown>
          </Col>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default NavMenubar;
